export default __webpack_public_path__ + "static/media/mask-mandate.55a5b515.png";